'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var getThemeProp = require('../../utils/getThemeProp.js');
var Card = _interopDefault(require('@material-ui/core/Card'));

var StyledRule = styled__default.hr(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  color: ", ";\n  border-top: 0;\n  opacity: 0.4;\n  margin: 0;\n"], ["\n  color: ", ";\n  border-top: 0;\n  opacity: 0.4;\n  margin: 0;\n"])), getThemeProp('palette.divider', '#E3EBF6'));
var StyledCard = styled__default(Card)(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  border-radius: 6px;\n  box-shadow: 0 3px 3px 0 rgba(18, 38, 63, 0.03);\n  border: 1px solid ", ";\n"], ["\n  border-radius: 6px;\n  box-shadow: 0 3px 3px 0 rgba(18, 38, 63, 0.03);\n  border: 1px solid ", ";\n"])), getThemeProp('palette.divider', '#E3EBF6'));
var templateObject_1, templateObject_2;

exports.StyledCard = StyledCard;
exports.StyledRule = StyledRule;
